import { api_config } from "../apis";
import { showNotification } from "@mantine/notifications";
import { APIClientGET } from "./APIClient";
import { clearStorageRedirectLogin, getAuthToken } from "../Uitls";
import RedCross from '../../assests/svg/RedCross.svg';
import du from "../language/du";

export async function DocumentsGet(accountId, res) {
      await APIClientGET({
        url: api_config.document_management.documents.documents_get,// +`?accountId=${accountId}&fileTypes=TenantDocument`,
        headers: {
            'Content-Type': 'application/json',
            Authorization: getAuthToken(),
          }
      })
        .then(response => {
            console.log('response.result: DocumentsGet: ', response);
            if (response.status === 200 && response.data.status) {
                res(response.data.result);
            } else if (response.data.status === false && response.status !== 400 && response.status !== 404){
                showNotification({
                    message: <div dangerouslySetInnerHTML={{__html: du.general.text_general_error}}/>,
                    id: 'general_error',
                    icon: <img src={RedCross} alt='red-tick'/>,
                });
                res(response.data.result);
            }else{
                res(response.data.result);
            }
        })
        .catch(e => {
            if(e.response.status === 401) {
                clearStorageRedirectLogin();
            }
            console.log('response.result: DocumentsGet: ', e.response.data);
            res(e.response.data.result);
            if (e.response.data.status === false && e.response.status !== 400 && e.response.status !== 404){
                showNotification({
                    message: <div dangerouslySetInnerHTML={{__html: du.general.text_general_error}}/>,
                    id: 'general_error',
                    icon: <img src={RedCross} alt='red-tick'/>,
                });
            }
        });
}

export async function DocumentsByPropertyGet(propertyId, res) {
    await APIClientGET({
      url: api_config.document_management.documents.documents_get + `/shared?propertyId=${propertyId}`,// +`?accountId=${accountId}&fileTypes=TenantDocument`,
      headers: {
          'Content-Type': 'application/json',
          Authorization: getAuthToken(),
        }
    })
      .then(response => {
          console.log('response.result: DocumentsByPropertyGet: ', response);
          if (response.status === 200 && response.data.status) {
              res(response.data.result);
          } else if (response.data.status === false && response.status !== 400 && response.status !== 404){
              showNotification({
                  message: <div dangerouslySetInnerHTML={{__html: du.general.text_general_error}}/>,
                  id: 'general_error',
                  icon: <img src={RedCross} alt='red-tick'/>,
              });
              res(response.data.result);
          }else{
              res(response.data.result);
          }
      })
      .catch(e => {
          if(e.response.status === 401) {
              clearStorageRedirectLogin();
          }
          console.log('response.result: DocumentsByPropertyGet: ', e.response.data);
          res(e.response.data.result);
          if (e.response.data.status === false && e.response.status !== 400 && e.response.status !== 404){
              showNotification({
                  message: <div dangerouslySetInnerHTML={{__html: du.general.text_general_error}}/>,
                  id: 'general_error',
                  icon: <img src={RedCross} alt='red-tick'/>,
              });
          }
      });
}